import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const GET_ENTITY_TYPES_QUERY = gql`
  query GetEntityTypes {
    getEntityTypes {
      cloudId
      isGeneral
      type
    }
  }
` as import('../../__generated__/ts-gql/GetEntityTypes').type;

export type GetEntityTypesQueryVariables = OperationVariables<
  typeof GET_ENTITY_TYPES_QUERY
>;
export type GetEntityTypesQueryResult = OperationData<
  typeof GET_ENTITY_TYPES_QUERY
>;

export type GetEntityTypesItem = NonNullable<
  ReturnType<typeof processData>
>[number];

export const useGetEntityTypes = (
  options?: QueryHookOptions<
    GetEntityTypesQueryResult,
    GetEntityTypesQueryVariables
  >
) => {
  const res = useQuery(GET_ENTITY_TYPES_QUERY, {
    context: { service: 'clients' },
    ...options,
  });

  const { data } = res;
  return React.useMemo(
    () => ({ ...res, data: data ? processData(data) : null }),
    [res, data]
  );
};

export function processData(data: GetEntityTypesQueryResult) {
  const rawRows = data?.getEntityTypes;
  const result: GetEntityTypesQueryResult['getEntityTypes'] | undefined | null =
    rawRows;
  return result;
}
